/**
 * Common reasons someone might need a follow-up SAR, beyond the specific
 * statutory gaps computed per organisation (services/statutory_gaps.py).
 * These are generic enough to apply anywhere — the follow-up dialog shows
 * them as tickable checkboxes alongside the statutory gaps and free text,
 * so a request can be built entirely from predetermined choices without
 * anyone needing to draft their own wording. `request_text` is what
 * actually goes into the letter (services/ai.py never sees or rewrites
 * these — only the free-text field is tidied).
 */
export const COMMON_FOLLOWUP_REASONS = [
  {
    id: 'incomplete_period',
    label: "It doesn't cover my whole time with them",
    request_text: 'A complete set of records covering my entire time with you, not only part of it.',
  },
  {
    id: 'mentioned_not_included',
    label: 'Something they sent mentions a document I don’t have',
    request_text: 'Any document referred to or mentioned in what you have already sent me, that was not itself included.',
  },
  {
    id: 'promised_not_sent',
    label: 'They told me something exists but did not send it',
    request_text: 'The specific record you have confirmed exists but did not include in your response.',
  },
  {
    id: 'unexplained_redactions',
    label: 'Parts were blacked out with no explanation',
    request_text: 'A written explanation for every redaction in what you sent, citing the specific legal exemption relied upon for each one.',
  },
  {
    id: 'different_elsewhere',
    label: 'The same event is described differently somewhere else',
    request_text: 'Clarification of a discrepancy I have found between your records and what another organisation holds about the same event.',
  },
];
